// Catalog product detail + config API lives in store service; re-export for catalog consumers.
import storeService from "../store/service";

const catalogService = {
  getCatalogProduct: storeService.getCatalogProduct,
  buildConfigParams: storeService.buildConfigParams,
  CONFIG_KEYS: storeService.CONFIG_KEYS,
};

export default catalogService;
